import {Details, MapNgrx} from '~model/ngrx/map-ngrx';
import {Action, createReducer, on} from '@ngrx/store';
import {
  mapClear,
  mapSetDetails,
  mapSetSelectedGroups,
  mapUpdateSelectedGroups,
  setMarkers,
  setPolygons,
  setUpdateMap,
} from './feature-map.actions';

export const initialState: MapNgrx = {
  clear: false,
  resizeMap: false,
  markers: [],
  polygons: [],
  details: {layer: null, item: null},
  selectedGroups: [],
};

const reducer = createReducer(
  initialState,
  on(setUpdateMap, (state, {resizeMap}) => ({...state, resizeMap})),
  on(setMarkers, (state, {markers, clear}) => ({...state, markers, clear: clear ?? false})),
  on(setPolygons, (state, {polygons, clear}) => ({...state, polygons, clear: clear ?? false})),
  on(mapSetDetails, (state, action: Details) => ({...state, details: action})),
  on(mapSetSelectedGroups, (state, {selected}) =>
    ({...state, selectedGroups: checkSelectedGroups(state.selectedGroups, selected)})),
  on(mapUpdateSelectedGroups, (state, {selected}) =>
    ({...state, selectedGroups: checkSelectedGroups(state.selectedGroups, selected, true)})),
  on(mapClear, () => ({...initialState, clear: true}))
);

export const FeatureMapReducer = (state: MapNgrx | undefined, action: Action) => reducer(state, action);

const checkSelectedGroups = (list: string[], id: string, update?: boolean) => {
  if (list.includes(id)) {
    return update ? list.filter(i => i !== id) : [];
  }
  const arr = id ? [id] : [];
  return update ? list.concat(arr) : arr;
};
